__turbopack_context__.v({
  "checklist": "ktXLnG_checklist",
  "checklistCheckbox": "ktXLnG_checklistCheckbox",
  "checklistItem": "ktXLnG_checklistItem",
  "checklistLabel": "ktXLnG_checklistLabel",
  "checklistList": "ktXLnG_checklistList",
  "checklistSublist": "ktXLnG_checklistSublist",
  "checklistText": "ktXLnG_checklistText",
  "checklistTextChecked": "ktXLnG_checklistTextChecked",
});
